import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import api from '../../utils/api';

const DonutChart = ({ data }) => {
  const [counts, setCounts] = useState(
    data || { institutions: 0, journalists: 0, activists: 0 }
  );

  useEffect(() => {
    if (data) {
      setCounts(data);
      return;
    }
    const fetchData = async () => {
      try {
        const [res1, res2, res3] = await Promise.all([
          api.get("/institutions/count/total"),
          api.get("/journalists/count/total"),
          api.get("/activists/count/total"),
        ]);
        setCounts({
          institutions: res1.data.count || 0,
          journalists: res2.data.count || 0,
          activists: res3.data.count || 0,
        });
      } catch (error) {
        console.error("Error fetching donut data:", error);
      }
    };
    fetchData();
  }, [data]);

  const total = counts.institutions + counts.journalists + counts.activists;

  const chartOptions = {
    options: {
      chart: {
        type: 'donut',
      },
      colors: ['#8E7CC3', '#29B6F6', '#cd728b'], // بنفس الألوان المطلوبة
      labels: ['الناشطين', 'الصحفيين', 'المؤسسات'],
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: true,
        position: 'bottom',
      },
      plotOptions: {
        pie: {
          donut: {
            size: '70%',
            labels: {
              show: true,
              total: {
                show: true,
                label: 'الإجمالي',
                formatter: () => total.toString(),
              },
            },
          },
        },
      },
    },
  };

  const series = [counts.activists, counts.journalists, counts.institutions];

  return (
    <React.Fragment>
      <ReactApexChart
        options={chartOptions.options}
        series={series}
        type="donut"
        height="300"
      />
    </React.Fragment>
  );
};

export default DonutChart;
